const debug = process.env.NODE_ENV !== 'production' ? true : false;

export default function log(...args) {
  if(debug) {
    console.log('Native Ads', '-', ...args);
  }
}
